import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import PaginatedResponse from "@/models/PaginatedResponse";
import Vue from "vue";
import CreateResponse from "@/models/CreateResponse";
import IBillService from "@/services/IBillService";
import Bill from "@/models/bill/Bill";
import BillListFilter from "@/models/bill/BillListFilter";
import BillListEntry from "@/models/bill/BillListEntry";
import BillCreate from "@/models/bill/BillCreate";
import BillUpdate from "@/models/bill/BillUpdate";
import ReportListFilter from "@/models/report/ReportListFilter";
import ReportListEntry from "@/models/report/ReportListEntry";
import {BillState} from "@/helpers/constants";

export default class AxiosBillService implements IBillService {

	public bill(id: string): Promise<Bill> {
		return Vue.$axios.get<Bill>(`/bill/${id}`).then(res => res.data);
	}

	public bills(filter: BillListFilter | null, options: AsiListTableOptions | null): Promise<PaginatedResponse<BillListEntry>> {
		return Vue.$axios.get<PaginatedResponse<BillListEntry>>('/bill', {
			params: {
				...filter,
				...options
			}
		})
			.then(res => res.data);
	}

	public create(model: BillCreate): Promise<CreateResponse> {
		return Vue.$axios.post<CreateResponse>('/bill', model).then(res => res.data);
	}

	public update(id: string, model: BillUpdate): Promise<null> {
		return Vue.$axios.patch(`/bill/${id}`, model).then(res => res.data);
	}

	public updateNotes(id: string, notes: string | null): Promise<null> {
		return Vue.$axios.put(`/bill/${id}/notes`, {
			notes: notes,
		}).then(res => res.data);
	}

	public delete(id: string): Promise<null> {
		return Vue.$axios.delete(`/bill/${id}`).then(res => res.data);
	}

	public state(id: string, requestedState: BillState): Promise<null> {
		return Vue.$axios.put(`/bill/${id}/state`, {
			state: requestedState,
		}).then(res => res.data);
	}

	public setPaid(id: string, isPaid: boolean): Promise<null> {
		return Vue.$axios.put(`/bill/${id}/paid`, {
			isPaid: isPaid,
		}).then(res => res.data);
	}

	public downloadPreview(id: string): Promise<any> {
		return Vue.$axios.get(`/bill/${id}/preview`, {
			responseType: 'blob'
		}).then(res => res);
	}

	public sendOrPrint(id: string): Promise<any> {
		return Vue.$axios.post(`/bill/${id}/send`, {}, {
			responseType: 'blob'
		}).then(res => res);
	}

	public reports(id: string, filter: ReportListFilter | null, options: AsiListTableOptions | null): Promise<PaginatedResponse<ReportListEntry>> {
		return Vue.$axios.get<PaginatedResponse<ReportListEntry>>(`/bill/${id}/report`, {
			params: {
				...filter,
				...options
			}
		})
			.then(res => res.data);
	}

	public reportsWithPotentialReports(id: string, filter: ReportListFilter | null, options: AsiListTableOptions | null): Promise<PaginatedResponse<ReportListEntry>> {
		return Vue.$axios.get<PaginatedResponse<ReportListEntry>>(`/bill/${id}/potential-report`, {
			params: {
				...filter,
				...options
			}
		})
			.then(res => res.data);
	}

	public assignReports(id: string, reports: string[]): Promise<null> {
		return Vue.$axios.put(`/bill/${id}/report`, {
			updatedReportIds: reports,
		}).then(res => res.data);
	}

}
